import { Brand } from './utils/Brand';

export const BrandedIdTypes = [
  'ApiKeyId',
  'AuthorizedContactId',
  'AuthZeroId',
  'BillSettingsId',
  'BorrowerId',
  'CompanyId',
  'LoanId',
  'LosId',
  'PortalUserId',
  'UserId',
  'PaymentId',
  'PaymentDueId',
  'DisbursementId',
  'LoanImportId',
  'LoanImportRowId',
  'LoanTransferExportId',
  'LoanNoteId',
  'EventId',
  'SideEffectId',
  'TransferId',
  'FeeId',
  'FeeLineItemId',
  'AuditLogId',
  'EntityId',
  'ExternalEntityId',
  'DrawId',
  'DocumentId',
  'EscrowCompanyId',
  'PayoffId',
  'PoolId',
  'PoolInternalId',
  'PropertyId',
  'TaskId',
  'TaskAuditLogId',
  'CompanyReportId',
  'CompanyReportDownloadId',
  'CompanyAuditLogId',
  'QcDocumentId',
  'EscrowSettingId',
  'EscrowDueId',
  'LoanChatMessageId',
  'UsioCompanyId',
  'RecurringCompanyReportId',
  'UsioAccountId',
  'RepayAccountId',
  'ChatQueryId',
  'EscrowPaymentHistoryItemId',
  'IndexRateId',
  'PaymentConfigId',
  'CustomFAQSectionId',
  'CustomFAQItemId',
  'CustomTemplateId',
  'CompanyWireSettingsId',
  'WorkoutPlanId',
  'LoanWorkflowId',
  'InvestorId',
  'LoanOwnerId',
  'MaturityHistoryItemId',
  'SftpSiteId',
  'ExternalLoanId',
  'LoanCreditReportId',
  'AppraisalId',
  'InspectionId',
  'NoteflowCompanyId',
  'PrincipalModificationId',
  'WriteoffId',
  'InvestorReportingId',
  'TeamId',
  'TeamPermissionsId',
  'TeamTasksId',
  'TeamSpecialistRoleId',
  'MERSMIN',
  'MERSOrgId',
  'WorkflowDefinitionId',
  'WorkflowInstanceId',
  'StepDefinitionId',
  'StepInstanceId',
  'StepActivationId',
  'StepNoteId',
  'DelinquentInterestSettingId',
  'BannerMessageId',
  'BankruptcyId',
  'NonPerformanceCodeForReportingCycleId',
  'ReportableEventId',
  'ForeclosureId',
  'QrpcId',
  'PaymentBreakdownId',
] as const;

export type BrandedIdKey = (typeof BrandedIdTypes)[number];
export type BrandedId<T extends BrandedIdKey> = Brand<string, T>;

export type ApiKeyId = BrandedId<'ApiKeyId'>;
export type AuthorizedContactId = Brand<string, 'AuthorizedContactId'>;
export type AuthZeroId = BrandedId<'AuthZeroId'>;
export type BillSettingsId = BrandedId<'BillSettingsId'>;
export type BorrowerId = BrandedId<'BorrowerId'>;
export type CompanyId = BrandedId<'CompanyId'>;
export type CompanyAuditLogId = BrandedId<'CompanyAuditLogId'>;
export type LoanId = BrandedId<'LoanId'>;
export type LosId = BrandedId<'LosId'>;
export type PortalUserId = BrandedId<'PortalUserId'>;
export type UserId = BrandedId<'UserId'>;
export type PaymentId = BrandedId<'PaymentId'>;
export type PaymentDueId = BrandedId<'PaymentDueId'>;
export type DisbursementId = BrandedId<'DisbursementId'>;
export type LoanImportId = BrandedId<'LoanImportId'>;
export type LoanImportRowId = BrandedId<'LoanImportRowId'>;
export type LoanTransferExportId = BrandedId<'LoanTransferExportId'>;
export type EventId = BrandedId<'EventId'>;
export type SideEffectId = BrandedId<'SideEffectId'>;
export type LoanNoteId = BrandedId<'LoanNoteId'>;
export type TransferId = BrandedId<'TransferId'>;
export type FeeId = BrandedId<'FeeId'>;
export type FeeLineItemId = BrandedId<'FeeLineItemId'>;
export type AuditLogId = BrandedId<'AuditLogId'>;
export type EntityId = BrandedId<'EntityId'>;
export type ExternalEntityId = BrandedId<'ExternalEntityId'>;
export type DrawId = BrandedId<'DrawId'>;
export type PayoffId = BrandedId<'PayoffId'>;
export type DocumentId = BrandedId<'DocumentId'>;
export type EscrowCompanyId = BrandedId<'EscrowCompanyId'>;
export type PoolId = BrandedId<'PoolId'>;
export type PoolInternalId = BrandedId<'PoolInternalId'>;
export type PropertyId = BrandedId<'PropertyId'>;
export type TaskId = BrandedId<'TaskId'>;
export type TaskAuditLogId = BrandedId<'TaskAuditLogId'>;
export type CompanyReportId = BrandedId<'CompanyReportId'>;
export type CompanyReportDownloadId = BrandedId<'CompanyReportDownloadId'>;
export type QcDocumentId = BrandedId<'QcDocumentId'>;
export type EscrowSettingId = BrandedId<'EscrowSettingId'>;
export type EscrowDueId = BrandedId<'EscrowDueId'>;
export type LoanChatMessageId = BrandedId<'LoanChatMessageId'>;
export type UsioCompanyId = BrandedId<'UsioCompanyId'>;
export type UsioAccountId = BrandedId<'UsioAccountId'>;
export type RepayAccountId = BrandedId<'RepayAccountId'>;
export type RecurringCompanyReportId = BrandedId<'RecurringCompanyReportId'>;
export type ChatQueryId = BrandedId<'ChatQueryId'>;
export type EscrowPaymentHistoryItemId = BrandedId<'EscrowPaymentHistoryItemId'>;
export type IndexRateId = BrandedId<'IndexRateId'>;
export type PaymentConfigId = BrandedId<'PaymentConfigId'>;
export type CustomFAQSectionId = BrandedId<'CustomFAQSectionId'>;
export type CustomFAQItemId = BrandedId<'CustomFAQItemId'>;
export type CustomTemplateId = BrandedId<'CustomTemplateId'>;
export type CompanyWireSettingsId = BrandedId<'CompanyWireSettingsId'>;
export type WorkoutPlanId = BrandedId<'WorkoutPlanId'>;
export type LoanWorkflowId = BrandedId<'LoanWorkflowId'>;
export type InvestorId = BrandedId<'InvestorId'>;
export type LoanOwnerId = BrandedId<'LoanOwnerId'>;
export type MaturityHistoryItemId = BrandedId<'MaturityHistoryItemId'>;
export type SftpSiteId = BrandedId<'SftpSiteId'>;
export type ExternalLoanId = BrandedId<'ExternalLoanId'>;
export type LoanCreditReportId = BrandedId<'LoanCreditReportId'>;
export type AppraisalId = BrandedId<'AppraisalId'>;
export type InspectionId = BrandedId<'InspectionId'>;
export type NoteflowCompanyId = BrandedId<'NoteflowCompanyId'>;
export type PrincipalModificationId = BrandedId<'PrincipalModificationId'>;
export type WriteoffId = BrandedId<'WriteoffId'>;
export type InvestorReportingId = BrandedId<'InvestorReportingId'>;
export type TeamId = BrandedId<'TeamId'>;
export type TeamPermissionsId = BrandedId<'TeamPermissionsId'>;
export type TeamTasksId = BrandedId<'TeamTasksId'>;
export type TeamSpecialistRoleId = BrandedId<'TeamSpecialistRoleId'>;
export type MERSMIN = BrandedId<'MERSMIN'>;
export type MERSOrgId = BrandedId<'MERSOrgId'>;
export type WorkflowDefinitionId = BrandedId<'WorkflowDefinitionId'>;
export type WorkflowInstanceId = BrandedId<'WorkflowInstanceId'>;
export type StepDefinitionId = BrandedId<'StepDefinitionId'>;
export type StepInstanceId = BrandedId<'StepInstanceId'>;
export type StepActivationId = BrandedId<'StepActivationId'>;
export type StepNoteId = BrandedId<'StepNoteId'>;
export type DelinquentInterestSettingId = BrandedId<'DelinquentInterestSettingId'>;
export type BannerMessageId = BrandedId<'BannerMessageId'>;
export type BankruptcyId = BrandedId<'BankruptcyId'>;
export type NonPerformanceCodeForReportingCycleId = BrandedId<'NonPerformanceCodeForReportingCycleId'>;
export type ReportableEventId = BrandedId<'ReportableEventId'>;
export type ForeclosureId = BrandedId<'ForeclosureId'>;
export type QrpcId = BrandedId<'QrpcId'>;
export type PaymentBreakdownId = BrandedId<'PaymentBreakdownId'>;
export type AllBrandedIds = BrandedId<BrandedIdKey>;

/**
 * Simple utility for creating typesafe branded id values
 *
 * @param _brandType - the type of branded id to create
 * @param id - the id to use, defaults to a random v4 UUID
 */
export const brandedId = <T extends BrandedIdKey>(
  _brandType: T,
  id: string = globalThis.crypto.randomUUID(),
): BrandedId<T> => id as BrandedId<T>;
